import { ReactNode } from "react";

interface PageTitleProps {
  children?: ReactNode;
}

function PageTitle({ children }: PageTitleProps) {
  return (
    <h1 className="text-42 sm:text-48 lg:text-6xl xl:text-[80px] xl:leading-1 font-medium">{children}</h1>
  );
}

export default PageTitle;
